import Chip from '@components/Chip';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { Fragment, useContext, useState } from 'react';

import DeleteIcon from './DeleteIcon';
import useContact from './hooks/useContact';
import styles from './styles.module.scss';

function Receiver() {
  const [to, setTo] = useState('other');
  const { state, setState } = useContext(GiftOrderContext);
  const { giftRecipients } = state;
  const { openContacts } = useContact((name, phoneNo) => {
    setState((prevState) => ({
      ...prevState,
      giftRecipients: [...prevState.giftRecipients, { name, phoneNo }],
    }
    ));
  });
  const deleteContact = (index: number) => {
    setState((prev) => ({
      ...prev,
      giftRecipients: prev.giftRecipients.filter((_, i) => i !== index),
    }));
  };
  return (
        <Column fullWidth spacing={6}>
            <Column spacing={22}>
                <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                    받는 사람
                </Text>
                <Chip.Container variant='fill'>
                    <Chip isSelected={to === 'me'}
                          onClick={() => setTo('me')}>
                        나에게 선물
                    </Chip>
                    <Chip isSelected={to === 'other'}
                          onClick={() => {
                            setTo('other');
                            openContacts();
                          }}>
                        연락처에서 추가
                    </Chip>
                </Chip.Container>
            </Column>
            {giftRecipients.map((contact, i) => (
                <Fragment key={`contact${i}`}>
                    <Row fullWidth justify='flex-end' >
                        <Row spacing={4} onClick={() => deleteContact(i)}>
                            <DeleteIcon/>
                            <Text color={colors.gray5} fontWeight='bold'
                                  className={styles.delete} >
                                삭제
                            </Text>
                        </Row>
                    </Row>
                    <Column spacing={20} fullWidth>
                        <TextField placeholder='연락처명을 입력하세요.'
                                   readOnly
                                   name='recipientName'
                                   value={contact.name}/>
                        <TextField placeholder='연락처를 입력하세요.'
                                   readOnly
                                   name='recipientPhone'
                                   value={contact.phoneNo}/>
                    </Column>
                </Fragment>
            ))}
        </Column>
  );
}

export default Receiver;
